export const comments_5480354 = {"data":{"data":[],"links":{}}}